export default "__VITE_ASSET__CXMl7dQX__"